import React from 'react'
import { Cupones as CuponesComponent } from "../../../Components/Player/Cupones"
import { Flex } from 'antd'
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';

export const Cupones = () => {
  const navigate = useNavigate();
  const isDesktopOrLaptop =  useMediaQuery({ query: '(min-device-width: 1224px)' });

  return (
    <Flex justify='center' align='center'>
      {
        isDesktopOrLaptop ? navigate("/404") : <CuponesComponent />
      }
    </Flex>
  )
}
